<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="物料组">
              <a-select
                showSearch
                :filterOption="filterOption"
                v-model="queryParam.materielGroupId"
                placeholder="请选择物料组"
              >
                <a-select-option value>全选</a-select-option>
                <a-select-option
                  v-for="(item, index) in materielGroupSelect"
                  :key="index"
                  :value="item.id"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="支持吨位">
              <a-input-number
                :min="0"
                :max="10000000"
                v-model="queryParam.queryTonnage"
                placeholder="支持吨位"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>

    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="物料组" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="mdl.materielGroupId"
            placeholder="请选择物料组"
            v-decorator="['materielGroupId',
            { initialValue: mdl.materielGroupId, rules: [{ required: true, message: '请选择物料组'}]}]"
          >
            <a-select-option
              v-for="(item, index) in materielGroupSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="最小吨位" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number
            :min="0"
            :max="10000000"
            v-model="mdl.minTonnage"
            placeholder="最小吨位"
            v-decorator="['minTonnage',
            { initialValue: mdl.minTonnage, rules: [{ required: true, message: '请输入最小吨位'}]}]"
            style="width: 100%"
          />
        </a-form-item>

        <a-form-item label="最大吨位" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number
            :min="0"
            :max="10000000"
            v-model="mdl.maxTonnage"
            placeholder="最大吨位"
            v-decorator="['maxTonnage',
            { initialValue: mdl.maxTonnage, rules: [{ required: true, message: '请输入最大吨位'}]}]"
            style="width: 100%"
          />
        </a-form-item>

        <a-form-item label="装卸时长（分钟）" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number
            :min="0"
            :max="10000"
            :step="1"
            oninput="this.value = this.value.replace(/[^0-9]/g, '');"
            v-model="mdl.loadTimeMiniute"
            placeholder="装卸时长"
            v-decorator="['loadTimeMiniute',
            { initialValue: mdl.loadTimeMiniute, rules: [{ required: true, message: '请输入装卸时长'}]}]"
            style="width: 100%"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import {
  materielLoadTimePage,
  materielGroupList,
  materielLoadTimeUpdate,
  materielLoadTimeSave,
  materielLoadTimeDelete
} from '@/api/basic'
import { formatDate } from '@/utils/date'
export default {
  name: 'MaterielLoadTime',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '物料组',
          dataIndex: 'materielGroupName',
          width: '150px',
          //fixed: 'left'
        },
        {
          title: '最小吨位',
          dataIndex: 'minTonnage',
          width: '110px',
        },
        {
          title: '最大吨位',
          dataIndex: 'maxTonnage',
          width: '110px',
        },
        {
          title: '装卸时长（分钟）',
          dataIndex: 'loadTimeMiniute',
          width: '180px',
        },
         {
          title: '创建人',
          dataIndex: 'createId',
          width: '110px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '240px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '110px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '240px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '140px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      // 物料分组下拉
      materielGroupSelect: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return materielLoadTimePage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()
  },
  methods: {
    loadSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = materielGroupList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.materielGroupSelect = res
      })
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd() {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.mdl.minTonnage >= this.mdl.maxTonnage) {
            this.$message.warning('最大吨位应大于最小吨位-', 3)
            return
          }
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            materielLoadTimeUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            materielLoadTimeSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          return materielLoadTimeDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
